import { Link } from "react-router-dom";
import { Mail, MapPin, ClipboardList, ArrowRight } from "lucide-react";
import { company, contactBg } from "../../mock";

export const FinalCTA = () => (
  <section id="contact" data-testid="contact-section" className="relative py-24 md:py-32 overflow-hidden">
    <img src={contactBg} alt="Omaha skyline" className="absolute inset-0 w-full h-full object-cover grayscale" />
    <div className="absolute inset-0 bg-[#05071F]/90" />
    <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center flex flex-col items-center">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-violet-400 mb-4">Engage the Sentry</p>
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white">
        Secure your future with {company.legalName}
      </h2>
      <p className="mt-6 text-slate-300 max-w-xl">
        One conversation. Zero obligation. Our advisory services are supplier-funded — you get enterprise-grade expertise at no cost.
      </p>
      <div className="mt-10 flex flex-col items-center gap-6">
        <Link to="/intake" data-testid="contact-intake-btn"
          className="inline-flex items-center justify-center gap-2 bg-cyan-400 text-[#05071F] font-semibold px-9 py-4 rounded-full hover:bg-cyan-300 transition-colors text-base">
          <ClipboardList className="w-5 h-5" /> Customer Intake & Discovery Form <ArrowRight className="w-4 h-4" />
        </Link>
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-8 text-sm text-slate-300">
          <a href={`mailto:${company.contactEmail}`} data-testid="contact-email-link" className="inline-flex items-center gap-2 hover:text-white transition-colors">
            <Mail className="w-4 h-4 text-cyan-400" /> {company.contactEmail}
          </a>
          <span data-testid="contact-location" className="inline-flex items-center gap-2">
            <MapPin className="w-4 h-4 text-cyan-400" /> {company.location}
          </span>
        </div>
      </div>
    </div>
  </section>
);
